export default {
  menu_search_placeholder: 'Search game',
  search_title: 'Search',
  search_placeholder: 'Search game',
  search_history: 'Search History',
  search_clear: 'Clear',
  search_popular: 'Popular Searches',
  search_recommended: 'Recommended Games',
  game_detail_title: 'Game',
  game_detail_rtp: 'RTP',
  game_detail_min_bet: 'MINIMUM BET',
  game_detail_play: 'Play',
  game_detail_preview: 'Game Preview',
  game_detail_recommend: 'Recommend Games',
  qb_monery: '₦',
  account: 'account',
  Depósito: 'Deposit',
  VIP: 'VIP',
  Saque: 'Withdrawal',
  Registro: 'Sign Up',
  Entrar: 'Sign In',
  Apostas: 'Bets',
  Agente: 'Agent',
  Promoção: 'Promotion',
  Reminder: 'Reminder',
  Início: 'Home',
  Bônus: 'Bonus',
  Enviar: 'Submit',
  Compartilhar: 'Share',
  Meu: 'Mine',
  BRL: 'NGN',
  ALL: 'ALL',
  noempt: 'No Records',
  // —— 品牌改版 i18n 补全(消除中文 fallback 泄漏 / 脱敏内部术语)——
  login_welcome: 'Take the leap.',
  responsible_footer: '18+ · Play responsibly',
  winner_empty: 'No winners yet',
  banner_load_failed: 'Failed to load banners. Showing the latest available.',
  home_game_unavailable: 'Game list is temporarily unavailable.',
  layout_read_unavailable: 'Page data is temporarily unavailable. Please try again later.',
  layout_entry_unavailable: 'Game entry is temporarily unavailable. Please try again later.',
  home_winning_unavailable: 'Winners list is temporarily unavailable.',
  region_select_required: 'Please select a valid region and try again.',
  country_list_unavailable: 'Country/region list is unavailable. Please try again later.',
  feature_unavailable: 'This feature is temporarily unavailable. Please try again later.',
  request_failed: 'Request failed. Please try again later.',
  service_unavailable: 'Service temporarily unavailable. Please try again later.',
  profile_read_failed: 'Profile data could not be loaded. Existing data has been kept.',
  settings_read_failed: 'Account security data could not be loaded. Existing settings have been kept.',
  wallet_balance_read_failed: 'Balance data could not be loaded. Existing balance has been kept.',
  login_required: 'Please log in to continue.',
  profile_refresh_failed: 'Profile data could not be refreshed. Please try again later.',
  logout_failed: 'Logout request failed. Please try again later.',
  save_failed: 'Save failed. Please try again later.',
  Recarregar: 'Reload',
  Receber: 'Receive',
  Recebido: 'Received',
  Regras: 'Rules',
  Obter: 'Obtain',
  Sucesso: 'Success',
  Cancelar: 'Cancel',
  Confirmar: 'Confirm',
  Detalhes: 'Details',
  TopNav_txt: 'Wheel',
  TopNav_txt1: 'VIP Check-in',
  TopNav_txt2: '100% First Deposit',
  TopNav_txt3: 'Treasure Chest Event',
  TopNav_txt4: 'CEV',
  TopNav_txt5: 'CFA',
  index_txt: 'Welcome to VUKAVI 🔥 You\'re one leap away from your first win. Deposit & get your bonus.',
  index_txt2: `Deposit Now`,
  home_txt: 'just withdrew',
  home_txt2: 'List of winners',
  home_txt3: 'More Benefits Await You on the Official Channels',
  home_txt4: 'Share on Social Media',
  home_txt5:
    'VUKAVI is an online gaming brand. Please play responsibly. 18+',
  home_txt6: '@2024 VUKAVI All rights reserved',
  home_txt7: 'Do not show again today',
  home_txt8: 'Never ask again',
  home_txt9: 'Deposit Now!',
  bonus_title: `Invite Partners`,
  bonus_title2: `First Deposit`,
  bonus_title3: `Daily Assistance Fund`,
  bonus_title4: `First Registration`,
  bonus_title5: 'Red Package',
  bonus_title6: `Treasure Chest Event`,
  bonus_title7: `VIP Upgrade Bonus`,
  bonus_title8: `Team Refunds`,
  bonus_title9: `VIP Sign-In Bonus`,
  bonus_txt: `<p>
            When you have sufficient time and promotional resources,
            we invite you to contact our manager directly! We will create a detailed weekly salary plan! As long as you have the will, as long as you have the courage! As long as you have the resources! We invite you to join us!
          </p>
          <p class="m-t-20">
            Conditions to become an agent: A well-known influencer on social media, passionate about promotion. Do you love the VUKAVI platform? Do you have a large number of followers or social groups that can convince a significant number of valid users to the VUKAVI platform? Cooperate with us long-term and participate in our operational plans and promotional activities.
          </p>
          <p class="m-t-20">
            We eagerly await your participation and financing: exclusive VIP benefits and exclusive commission settlement services. Other rewards, such as weekly profit dividends. High weekly salary: 10,000 - 50,000 (no upper limit).
          </p>`,
  bonus_txt2: `<p>
          Rules:<br />1. Participating in the partner's weekly salary plan and
          platform activities can be done simultaneously.<br />2.
          The weekly salary is paid punctually every Monday.<br />3.Our
          weekly salary plan has no restrictions. If your followers are
          active or below 10,000, you can contact our manager to create a
          unique VIP weekly salary plan for you.<br />
          4. The weekly salary is directly deposited into your platform account.
          <br />5. We reject fake accounts. Any detected fake account will
          be permanently blocked.
        </p>`,
  bonus_txt3: `<p class="font-color">
            First deposit Event duration: From now until a final date to be
            announced later.
          </p>
          <p class="m-t-20 m-b-10 f-t-16 f-w">Event Rules:</p>
          <p class="font-color">
            Users can request bonus rewards based on their first deposit, with a maximum bonus of 100% of  per single deposit. To withdraw the bonus, a required bet value must be reached, calculated as |Bonus × n times| of the deposit amount.
          </p>
          <p class="m-t-20 f-t-16 f-w m-b-10">
            First Deposit Bonus Levels:
          </p>
          <div class="font-color" style="line-height: 20px">
            <p>
              Deposit Amount Bonus Percentage Wagering Requirement
              (Multiplier)
            </p>
            <p>3000-4999 177 1</p>
            <p>5000-9999 277 1</p>
            <p>10000-29999 777 1</p>
            <p>30000-49999 1777 1</p>
            <p>50000-99999 3777 1</p>
            <p>100000-299999 7777 1</p>
            <p>300000-499999 17777 1</p>
            <p>500000 57777 1</p>
            <p class="m-t-20 f-t-16 f-w m-b-10" >
              Second deposit bonus levels:
            </p>
            <p>
              Deposit Amount Bonus Percentage Wagering Requirement
              (Multiplier)
            </p>
               <p>3000-4999 10% 1</p>
            <p>5000-9999 10% 1</p>
            <p>10000-29999 10% 1</p>
            <p>30000-49999 10% 1</p>
            <p>50000-99999 10% 1</p>
            <p>100000-299999 10% 1</p>
            <p>300000-499999 10% 1</p>
            <p>500000 10% 1</p>
                 <p class="m-t-20 f-t-16 f-w m-b-10" >
              Three deposit bonus levels:
            </p>
            <p>
              Deposit Amount Bonus Percentage Wagering Requirement
              (Multiplier)
            </p>
              <p>3000-4999 10% 1</p>
            <p>5000-9999 10% 1</p>
            <p>10000-29999 10% 1</p>
            <p>30000-49999 10% 1</p>
            <p>50000-99999 10% 1</p>
            <p>100000-299999 10% 1</p>
            <p>300000-499999 10% 1</p>
            <p>500000 10% 1</p>
          </div>

          <p class="m-t-20 f-t-16 f-w m-b-10">Example:</p>
          <div class="font-color" style="line-height: 20px">
            <p>
              A deposit of 2,000  will earn you a 5% bonus (100 ).
            </p>
            <p>
              A deposit of 2,000  will earn you a 5% bonus (100 ).
              This means you need to bet (100  × 5) + 2,000  = 2,500
              .
            </p>
            <p>
              Once 2,500  in bets are made, the bonus can be withdrawn.
            </p>
            <p>A bet of 20,000  will unlock the bonus.</p>
            <p class="m-t-20 f-t-16 f-w m-b-10">
              Notes:
            </p>
            <p>
              1. This promotion cannot be canceled after being successfully applied. To remove any account restrictions, the specific bet requirement of the promotion must be completed.
            </p>
            <p>
              2. If arbitrage, hedging, or any dishonest profit-making behavior is detected, the promotional eligibility will be canceled, and all bonus rewards will be lost.
            </p>
            <p>
              3. The valid bet value includes only settled bets that resulted in a win or loss. Any canceled or voided events will not count towards the valid bet.
            </p>
            <p>
              4. Every valid player can participate. If any violations are detected, we reserve the right to review and reclaim any bonuses and profits generated indefinitely.
            </p>
            <p>
              5. If you withdraw before meeting the bet requirements, the bonus will be deducted by the system.
            </p>
          </div>`,
  bonus_txt4: `Recharge Now`,
  bonus_txt5: `Ensure a unique account, phone number, and card number. Multiple
          registrations to obtain bonuses will result in a permanent account ban.`,
  bonus_txt6: `LSS CASHCACK`,
  bonus_txt7: `Cashback`,
  bonus_txt8: 'Cashback Rate VIP',
  bonus_txt9: 'Loss',
  bonus_txt10: 'Cashback Amount',
  bonus_txt11: `<p class="m-t-15 l-h-20" style="margin-left: 5px">
          1.You can receive a cashback reward opportunity every day.
        </p>
        <p class="content-c5--cash">
          2.The bet value is calculated from 00:00 yesterday until 00:00 today.
        </p>
        <p class="content-c5--cash">
          3.You can register the reward between 05:00 and 23:59 today.
        </p>
        <p class="content-c5--cash">
          4.The cashback value is based on the actual win/loss amount, and you
          can receive the corresponding cashback as shown in the table.
        </p>
        <p class="content-c5--cash">
          5.If you do not place any bets during the reimbursement period or if
          your winnings exceed the amount bet, you will not be eligible for the
          reimbursement.
        </p>
        <p class="content-c5--cash">
          6.The maximum cashback per person, per time, is 1,000,000.
        </p>
        <p class="content-c5--cash">
          7.However, before you can withdraw the reward, you must make at
          least 2 rounds of bets using the received value.
        </p>
        <p class="content-c5--cash">
          8.The final decision on all matters is at the discretion of VUKAVI.
        </p>`,
  bonus_txt12: `Event Details`,
  bonus_txt13: `New registered users will receive a random bonus of ₦3500
        for free. Complete the assigned tasks to receive the corresponding
        rewards;`,
  bonus_txt14: `<p class="f-t-16 f-w m-t-15" style="color:#ffffff">Event Details</p>
        <p class="m-t-15">
          1.After registering as a member, complete the assigned tasks to
          receive the corresponding rewards;
        </p>
        <p class="m-t-10">2.Bonus available only in PG slot games</p>
        <p class="m-t-10">
          3.Each member and each IP address can only participate once. If
          multiple accounts use the same IP address, they will be considered the
          same person and will not be able to participate again;
        </p>
        <p class="m-t-10">
          4.Members who have obtained profits using the bonuses from this event
          and have requested withdrawals. The VIP level needs to reach VIP2 to
          make complete withdrawals.
        </p>
        <p class="m-t-10">
          5.VUKAVI reserves the right to change, interrupt, or cancel the
          activity at any time.
        </p>`,
  bonus_txt15: `Connect & Register`,
  bonus_txt16: `Successfully collected.`,
  bonus_txt17: `RELEASE TIME`,
  bonus_txt18: `12:00-12:59`,
  bonus_txt19: `18:00-18:59`,
  bonus_txt20: `21:00-21:59`,
  bonus_txt21: `<p class="m-t-10">
          1.You will receive a cashback reward every week.
        </p>
        <p class="m-t-10">
          2.The bet value is calculated from 00:00 on Monday to 23:59 on
          Sunday.
        </p>
        <p class="m-t-10">
          3.You can redeem your reward from 00:00 of the following Monday to
          23:59 of the following Monday.
        </p>
        <p class="m-t-10">
          4.Cashback is calculated by multiplying your actual loss by the
          cashback percentage.
        </p>
        <p class="m-t-10">
          5.If you do not place any bets during the cashback period or if your
          winnings are greater than your losses from the previous week, you will
          not receive cashback.
        </p>
        <p class="m-t-10">
          6.The maximum cashback per person per week is 5,000 .
        </p>
        <p class="m-t-10">
          7.However, before you can withdraw the reward, you need to make at
          least 3 rounds of bets with the received value.
        </p>
        <p class="m-t-10">
          8.The final decision on all matters is at the discretion of VUKAVI.
        </p>`,
  bonus_txt22: `Deposit and Participate`,
  bonus_txt23: `My Link`,
  bonus_txt24: `Invite Code:`,
  bonus_txt25: `Valid Subordinates`,
  bonus_txt26: `people`,
  bonus_txt26_single: `person`,
  bonus_txt27: `What is a valid promotional number?`,
  bonus_txt28: `(Meet all the requirements below)`,
  bonus_txt29: `subordinate's total doposits`,
  bonus_txt30: `10000 or more`,
  bonus_txt31: `subordinate's total wager`,
  bonus_txt32: `50000 or more`,
  bonus_txt33: `<p >
          1.Invite friends to open the Treasure Chest. By completing different
          quantities of invitations, you can win the corresponding chests, with
          a maximum value of 20,000,000. The more friends you develop, the
          greater the reward.
        </p>
        <p class="m-t-10">
          2.This activity is an additional gift from the platform and also
          accumulates other rewards and agency commissions, that is, you can
          enjoy multiple rewards simultaneously. New registered direct
          subordinates in each cycle will only be valid if they meet the
          conditions of the activity.
        </p>
        <p class="m-t-10">
          3.Members of lower levels can make valid bets on the platform without
          restrictions.
        </p>
        <p class="m-t-10">
          4.Rewards must be redeemed manually on the platform; expired rewards
          will be distributed automatically.
        </p>
        <p class="m-t-10">
          5.The bonus (excluding capital) granted in this event requires 0
          valid bets to be withdrawn. Bets are not limited to gaming platforms.
        </p>
        <p class="m-t-10">
          6.This event is intended only for normal manual operations of the
          account holder. The use of accounts, cheating software, bots, bets
          between different accounts, mutual manipulation, arbitrage, use of
          APIs, protocols, exploitation of vulnerabilities, group control, or
          other technical means is prohibited. Otherwise, rewards may be
          canceled or deducted, and the account may be frozen or even placed
          on the blacklist.
        </p>
        <p class="m-t-10 m-b-20">
          7.To avoid discrepancies in the interpretation of the text, the
          platform reserves the right to the final interpretation of this
          event.
        </p>`,
  bonus_txt34: `Reward Value:`,
  bonus_txt35: `VIP Cashback Rate`,
  bonus_txt36: `Level`,
  bonus_txt37: `Reward`,
  bonus_txt38: `<p class="content-c5-sign" style="margin-top: 15px">
        During the Event Period, Users Can Receive Rewards for VIP Level
        Upgrades. Rules:
      </p>
      <p class="content-c5-sign">
         1. Users are required to complete the recharge for the specified VIP level, and only after that can they claim the reward amount corresponding to the VIP level. 
      </p>
      <p class="content-c5-sign">
        2. This event is only for normal account holders. It is prohibited to participate through methods such as renting accounts, using plugins, betting from different locations, etc. If such methods are detected, rewards will be canceled, and the account may be frozen or blacklisted. Any activities such as order brushing, arbitrage, or using technical means like group control agreements will result in account suspension.  
      </p>
      `,
  bonus_txt39: `Team Refunds`,
  bonus_txt40: `<p class="m-t-10">
          1. Your team will receive a rebate reward every week.
        </p>
        <p class="m-t-10">
          2. The team's total bet amount is calculated from 00:00 Monday to 23:59 Sunday.
        </p>
        <p class="m-t-10">
          3. You can redeem your team's rebate reward from 00:00 of the following Monday to 23:59 of Monday.
        </p>
        <p class="m-t-10">
          4. The team rebate is calculated by multiplying your team's actual total loss by the rebate percentage.
        </p>
        <p class="m-t-10">
          5. If your team does not place any bets during the rebate period or if your team's total winnings are greater than the total losses from the previous week, your team will not receive the rebate.
        </p>
        <p class="m-t-10">
          6. The maximum rebate per team per week is subject to the platform's current limit.
        </p>
        <p class="m-t-10">
          7. However, before you can withdraw the team rebate reward, your team needs to place at least 3 rounds of bets with the received rebate amount.
        </p>
        <p class="m-t-10">
          8. The final decision on all matters related to team rebates is at the discretion of VUKAVI.
        </p>`,
  bonus_txt41: `VIP Daily Reward Rules`,
  bonus_txt42: `After reaching the corresponding level, if the valid bet value is >=
        2 million or the deposit value >= 200,000 within 2 days, you can redeem
        the reward, which will be issued in real-time to your wallet on the
        platform.`,
  bonus_txt43: `VIP Cashback Rate`,
  mine_txt: `Account ID:`,
  mine_txt2: `Growth Value Required:`,
  mine_txt3: `Total Deposits:`,
  mine_txt4: `Are you sure you want to log out?`,
  mine_txt5: `Wallet Details`,
  mine_txt6: `Game History`,
  mine_txt7: `Share`,
  mine_txt8: `Account Name`,
  mine_txt9: `Change Login Password`,
  mine_txt10: `Change Withdrawal Password`,
  mine_txt11: `Account`,
  mine_txt12: `Avatar`,
  mine_txt13: `Privacy Policy`,
  mine_txt14: `Log Out`,
  recordOrder_title: 'Order List',
  recordOrder_txt: 'Issuing to',
  recharge_success: 'Recharge Successful',
  order_reversed: 'Order Reversed',
  mc_read_all: 'Read All',
  mc_delete_read: 'Delete Read',
  mc_inbox: 'Inbox',

  orderDetail_title: 'Order Details',
  orderDetail_txt: 'Transaction Type',
  orderDetail_txt2: 'Refund Method',
  orderDetail_txt3: 'Refund Date',
  orderDetail_txt4: 'Order Number',
  orderDetail_txt5: 'Bank Account Number',
  orderDetail_txt6: 'Note',
  authName_title: 'Real Name Authentication',
  authName_txt: 'Real Name',
  authName_txt2: `Ensure that your name matches the bank account name
        to ensure security.`,
  authName_txt3: 'Enter your name',
  bankAdd_txt: 'Manage Account',
  setPassWord_title: 'Change Withdrawal Password',
  setPassWord_txt: `This is your first withdrawal, you need to set the withdrawal
        password first`,
  setPassWord_txt2: `Set your withdrawal password`,
  setPassWord_txt3: `Old password:`,
  setPassWord_txt4: `New password:`,
  setPassWord_txt5: `Warm reminder: The withdrawal password is very important. Remember
        to remember it and keep it safe. Do not tell anyone. If it is lost, the
        assets will not be recovered.`,
  setPassWord_txt6: `6 digits`,
  setPassWord_txt7: `The passwords entered twice are inconsistent`,
  avatar_title: 'Select Avatar',
  bank_title: `Bank Card`,
  bank_txt: 'Remove this bank card?',
  bank_txt2: `Withdrawal Password`,
  bank_empty: 'No Bank Card',
  bank_empty_desc: 'Add a bank card for withdrawals',
  bank_add: 'Add Bank Card',
  bank_pwd_ph: 'Enter withdrawal password',
  billGame_title: `Game Record`,
  billGame_txt: `Game:`,
  billGame_txt2: `Bet:`,
  billGame_txt3: `Win:`,
  billGame_txt4: `Today`,
  billGame_txt5: `Yesterday`,
  billGame_txt6: `This Week`,
  billGame_txt7: `Last Week`,
  billGame_txt8: `This Month`,
  billGame_txt9: `Last Month`,
  billGame_txt10: `All`,
  gameHall_txt: `Complete the initial deposit to enter the game.`,
  gameHall_txt2: `Due to game maintenance by the manufacturer, please come back later.`,
  gameHall_txt3: `The game functionality has been disabled. Please contact online support for help.`,
  gameHall_txt4: `Insufficient balance, please reload and continue.`,
  gameHall_txt5: `Are you sure you want to exit the current game?`,
  passwordLogin_title: `Change Login Password`,
  passwordLogin_txt: `Old password`,
  passwordLogin_txt2: `New password`,
  passwordLogin_txt3: `Login password`,
  passwordLogin_txt4: `Remember that negligence in protecting your password can lead to irreversible losses. Keep it confidential and you will ensure the continuous security of your information.`,
  passwordLogin_txt5: `Enter the old password.`,
  passwordLogin_txt6: `Enter the login password.`,
  passwordLogin_txt7: `The new password is the same as the old one.`,
  privacy_title: `Privacy Policy`,
  privacy_txt: `
    <p class="m-t-20 f-t-16 f-b font-color">
      Privacy Policy and Personal Data Protection
    </p>

    <p style="line-height: 20px; margin-top: 10px">1. Introduction:</p>
    <p class=" m-t-10" style="line-height: 20px">
      At VUKAVI, our goal is to provide users with the best possible
      experience. Therefore, to offer increasingly personalized services to you
      (our user), we need to understand your gaming habits and interactions.
      However, the privacy and security of your personal data are always our top
      priority. This is why we wish to explain in a transparent and detailed
      manner how we collect, store, share, and use your personal data, as well
      as clarify the choices and control options available to you when deciding
      to share such personal data. This is the main purpose of this Privacy
      Policy and Personal Data Protection Policy ("Policy").
    </p>

    <p class="m-t-10" style="line-height: 20px">2. About This Policy</p>

    <p class="m-t-10" style="line-height: 20px">
      This Policy describes the key details about the relationship between
      users' personal data and VUKAVI. This Policy applies to all services of
      VUKAVI and any related services (collectively referred to as "VUKAVI
      Services"). The terms governing the use of VUKAVI Services by users are
      defined in our Terms and Conditions.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We may develop new services or offer additional services from time to
      time. If the launch of these new or additional services results in changes
      to the way we collect and process personal data, we will provide
      additional information along with supplementary terms or policies. Unless
      specifically indicated, whenever we introduce new or additional services,
      they will be governed by this Policy.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      The purpose of this Policy is:
    </p>

    <p class=" m-t-10" style="line-height: 20px">
      To ensure that users are fully informed about the personal data we collect
      about them, why we collect and use this data, and with whom we share it;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To explain how we use the personal data shared with us by users to provide
      a good experience when using VUKAVI services;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To explain to users their respective rights and options regarding the
      personal data we collect and process, and how we protect their privacy.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We hope that this Policy helps users understand our commitment to their
      privacy. If they have any concerns or questions, please refer to Section
      14, "Contact," below, for information on how to get in touch with us.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      On the other hand, if users do not agree with the content of this Policy,
      we declare that users have the freedom to decide whether to use and/or
      continue using VUKAVI services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      User Rights and Preferences: Offering You Choices and Control:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      If you are not aware, the laws of the EU and Brazil, namely the "General
      Data Protection Regulation" (or "GDPR") and the "General Data Protection
      Law of Brazil" (or "LGPD"), respectively, confer certain rights on
      individuals in relation to their personal data. In accordance with the
      applicable legal provisions, subject to any restrictions therein, the
      rights conferred on individuals are as follows:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Right of Access – The right to be informed and request access to the
      personal data we process about you;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Right to Rectification – The right to request that we correct or update
      personal data that is inaccurate or incomplete;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Right to Erasure – The right to request that we delete your personal data
      from our databases;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Right to Restriction – The right to request that we temporarily or
      permanently cease processing all or part of your personal data;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Right to Object – The right to object to the processing of your personal
      data for reasons related to your particular situation at any time, the
      right to object to the processing of your personal data for direct
      marketing purposes;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Right to Data Portability – The right to request a copy of your personal
      data in electronic format and transmit this data to third-party services;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Right Not to Be Subject to Automated Decisions – The right not to be
      subject to decisions based solely on automated processing, including
      profiling, that significantly affect you legally or similarly.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To enable users to easily exercise these rights and register their
      preferences regarding the use VUKAVI makes of their personal data, we
      provide the following options through the Privacy Settings on the "My
      Profile" page:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      1. Control certain categories of personal data that we process;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      2. Manage the personal data you make public;
    </p>

    <p class="m-t-10" style="line-height: 20px">3. Set sharing preferences.</p>

    <p class="m-t-10" style="line-height: 20px">
      If we send electronic marketing communications based on your consent or
      another applicable legal basis, users can withdraw their consent or
      opt-out at any time, at no cost. To do so, simply use the unsubscribe link
      in the email itself to remove yourself from the mailing list.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      If you have any questions about your privacy, rights, or how to exercise
      such rights, you should contact our Data Protection Officer by sending an
      email to our customer support, and we will respond to the relevant user
      in a reasonable time after verifying their identity.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      If you are not satisfied with the way we handle your personal data, you
      may also lodge a written complaint with the data protection authority in
      your jurisdiction.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      4. How Do We Collect Users' Personal Data?
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We collect users' personal data in the following ways:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      When users register for VUKAVI services: After registration, we collect
      certain personal data, such as, but not limited to: email address, full
      name, gender, country/region, IP address, device used and its identifiers,
      so that they can use the relevant VUKAVI services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Through the use of VUKAVI services: When users use VUKAVI services, we
      collect personal data about their use of the relevant VUKAVI services,
      such as games played, gaming history, list of devices used to access the
      service, nickname used when accessing from a single device, changes in
      ranking positions, changes in virtual point balances for each user, IP
      address used for access, and other information necessary to achieve our
      business objectives. For example, users may also occasionally provide us
      with additional personal data or grant us permission to collect other
      personal data to offer more functionalities or features. The personal data
      collected also allows us to mitigate risks related to users and services
      and/or prevent fraud.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Through third parties – We may also receive personal data related to users
      and their activities from third parties (including advertisers and
      partners we work with) so that we can provide VUKAVI services (see
      Section 7 "Sharing Users' Personal Data" below). If the relevant users
      authorize the third party or MEGA SLOTS to share such data, or if VUKAVI
      has a legitimate interest in using this personal data to provide VUKAVI
      services, we will use this personal data.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      As described below, we will not collect users' photos, exact geographical
      location of mobile devices, voice data, or contact lists without prior
      user authorization. You can always change your mind and withdraw your
      consent.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      5. What Types of Users' Personal Data Do We Collect?
    </p>

    <p class="m-t-10" style="line-height: 20px">
      In the table below, we summarize the categories of users' personal data
      that we collect and use:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Category of Personal Data, Description of Category
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Account Registration Information, These are the personal data provided by
      the user or collected by us so that the user can use VUKAVI services.
      This includes the user's name, identification documents, email address,
      date of birth, gender, and physical address. Users must provide certain
      personal data when creating an account. Users may also choose to provide
      additional personal data to personalize their experience.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Usage Data. Refers to the personal data collected when users use VUKAVI
      services, which may include: - Information about the type of VUKAVI
      service plan. - Information about users' interactions with VUKAVI
      services, such as games played, gaming history, list of devices used to
      access the service, history of nicknames used to access from a single
      device, changes in ranking positions, changes in virtual point balances
      for each user, and interactions with other VUKAVI users. - This may also
      include information about the use of third-party applications and any
      advertisements you receive. - Content of users that they post on VUKAVI
      (as defined in the Terms and Conditions), including messages sent and/or
      received through VUKAVI and interactions with VUKAVI customer support.
      - Technical data, which may include URL information, cookie data, user IP
      address, devices used to access VUKAVI services, unique device
      identifiers, device attributes, and types of network connections (Wi-Fi,
      3G, LTE, Bluetooth, etc.), network provider, network and device
      performance, browser, language, digital rights management information,
      operating system, and version of the VUKAVI application.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Personal Data Collected with Your Consent Allows Us to Provide Additional
      Functionalities or Features:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Category of Personal Data | Description of Category
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Optional Mobile Data <br />In addition to the mobile data we collect to
      provide VUKAVI services (as described above), users may choose to
      authorize us to collect additional personal data from their mobile devices
      so that we can provide the following features and functionalities that
      enhance your experience with VUKAVI services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Without user consent, we will not collect any of the following personal
      data:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      User Photos – If users grant us access to their photos or camera, we will
      only collect the images they specifically choose to share with us and the
      metadata associated with those images, such as file type and image size.
      We will never upload or import the entire photo library or camera roll of
      the user.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Exact Geographical Location of User's Mobile Device – If users authorize
      access to specific locations, we may use the GPS or Bluetooth of the user
      to provide VUKAVI services that require exact location data. Note that
      this does not include the user's IP address. We use the user's IP address
      to determine a non-exact geographical location, such as the country/region
      they are in, for the purpose of complying with our Terms and Conditions.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      User Contact List – If users authorize access to their contact list, we
      may review the contact list stored on their devices to help them find
      friends who are using MEGA SLOTS.
    </p>

    <p class="m-t-10" style="line-height: 20px">Payment Information</p>

    <p class="m-t-10" style="line-height: 20px">
      If users register for a trial period or make any purchases through
      VUKAVI services (as defined in the Terms and Conditions), we may collect
      these personal data. The data actually collected may vary depending on the
      payment method, but may include the following:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Name<br />
      Date of birth<br />
      ID<br />
      Type of debit or credit card, expiration date, and some digits of the card
      number<br />
      Physical address<br />
      Phone number<br />
      User's transaction history<br />
      If users choose to pay by invoice, we will provide their personal data to
      our payment processor for credit checks and to send invoices to the user.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Special Offers, Contests, and Lotteries
    </p>

    <p class="m-t-10" style="line-height: 20px">
      These personal data are used to allow users to register and participate in
      special offers. The personal data collected may vary depending on the
      special offer.
    </p>

    <p class="m-t-10" style="line-height: 20px">Marketing Data</p>

    <p class="m-t-10" style="line-height: 20px">
      These personal data are used to allow VUKAVI and its partners/service
      providers to send marketing information to users:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      By email<br />
      When using VUKAVI services<br />
      Directly from third parties.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      6. For What Purposes Do We Use Users' Personal Data?
    </p>

    <p class="m-t-10" style="line-height: 20px">
      When users use VUKAVI services or interact with them, we use various
      technologies to process the personal data collected for various reasons.
      In the table below, we list the reasons for which we process users'
      personal data, the legal basis for our actions, and the categories of
      personal data (as defined in Section 5 "What Types of Personal Data Do We
      Collect About Users?") used for the following purposes:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Explanation of the reasons for processing personal data by VUKAVI
      ("Processing Purposes")<br />
      Legal Basis for Processing Purpose<br />
      Categories of Personal Data Used for Processing Purpose
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To provide, personalize, and enhance the user's experience with the
      VUKAVI service and other services and products provided by VUKAVI,
      such as offering personalized, location-based, or location-specific
      content and recommendations, features, and advertisements (including
      third-party products and services) within or outside of VUKAVI.<br />
      Performance of contract<br />
      Account registration data, service usage data, and, if applicable,
      optional mobile data
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To ensure the integrity of the ranking systems provided and reduce fraud
      and collusion related to users in the VUKAVI entertainment environment.
      Performance of contract, legitimate interests Account registration data,
      service usage data
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To understand how users access and use the VUKAVI service, aiming to
      ensure the technical functionality of VUKAVI services, develop new
      products and services, and analyze users' use of VUKAVI services,
      including their interactions with the application, as well as advertising,
      products, and services related to or provided through MEGA SLOTS.<br />
      Performance of contract, legitimate interests Account registration data,
      service usage data
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To establish communication with users for purposes related to the VUKAVI
      service. Performance of contract, legitimate interests Account
      registration data, service usage data
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To process users' payments and prevent or identify fraudulent activities,
      including fraudulent payments and misuse of MEGA SLOTS services.<br />
      Performance of contract, legal obligations, legitimate interests Account
      registration data, service usage data, payment information
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To communicate directly with users or through our partners for the
      following purposes: Performance of contract, legitimate interests Account
      registration data, service usage data, payment information
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Marketing<br />
      Surveys<br />
      Participation in contests and special offers
    </p>

    <p class="m-t-10" style="line-height: 20px">
      In accordance with any consent that the user may have granted to VUKAVI
      (such as through privacy settings), by email, notifications, or other
      messages.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Consent<br />
      Legitimate interests
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Contest and lottery data<br />
      Marketing data
    </p>

    <p class="m-t-10" style="line-height: 20px">
      To provide users with functionalities, information, advertisements, or
      content based on the user's exact location.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Consent<br />
      Optional mobile data
    </p>

    <p class="m-t-10" style="line-height: 20px">
      The purposes for which we use anonymized and aggregated information
      include testing our IT systems, research, data analysis, marketing
      modeling and promotion, enhancing VUKAVI services, and developing new
      functionalities and features for VUKAVI services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      7. Sharing of Users' Personal Data:<br />
      Listed below are the categories of recipients who may receive personal
      data collected or generated through the use of MEGA SLOTS services (as
      applicable):
    </p>

    <p class="m-t-10" style="line-height: 20px">Public Information</p>

    <p class="m-t-10" style="line-height: 20px">
      The following personal data of the user will always be publicly available
      on VUKAVI services: user nickname, profile image, gaming performance
      information, and account creation date, as well as any other personal data
      that can be verified on the user's profile page.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Personal Data Shared by the User
    </p>

    <p class="m-t-10" style="line-height: 20px">
      The following personal data will only be shared with the categories of
      recipients listed below if:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      The user selects a specific feature of VUKAVI services that requires the
      sharing of personal data to use the feature correctly. <br />The user
      explicitly authorizes the sharing of personal data, such as selecting the
      appropriate settings in the privacy settings of VUKAVI services.<br />
      Category of Content<br />
      Reason for Sharing
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Third-party applications used to log in to MEGA SLOTS<br />
      When accessing your VUKAVI account from a third-party application (such
      as a social media app), VUKAVI may share data to link the user's account
      in both records, that is, the VUKAVI network and any third party.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      If the user associates their MEGA SLOTS account credentials with a
      third-party application, such third-party application may have access to
      certain service usage data, stored content, and activities. Before
      connecting to a third-party application, the user will be informed that
      their personal data will be shared with and/or accessible by such
      third-party applications.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Community <br />When a user joins the VUKAVI community, they must use
      the same nickname as their account. Such user nicknames will be publicly
      displayed to anyone accessing the VUKAVI community area, along with any
      questions, comments, and other content they choose to publish or make
      public through the privacy settings of VUKAVI services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      For more detailed information on public information and the content that
      users share with third parties, please refer to Section 3, "User Rights
      and Preferences: Offering You Choices and Control" in this policy and the
      privacy settings.
    </p>

    <p class="m-t-10" style="line-height: 20px">Information We May Share</p>

    <p class="m-t-10" style="line-height: 20px">
      Category of Content<br />
      Reason for Sharing
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Service providers and other parties We use technical service providers for
      the infrastructure necessary to operate VUKAVI services, especially
      those that host, store, manage, and maintain the VUKAVI application, its
      content, and the data we process.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We use technical service providers to help us communicate with users, as
      described in Section 6 of this policy.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We also use marketing and advertising partners to display more
      personalized content or to help us understand how users are using VUKAVI
      services and provide better services. We may also share personal data with
      certain marketing and advertising partners to send promotional information
      about VUKAVI to users.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      In addition, we use payment partners; however, in this case, we do not
      store or share credit card data or other payment methods, and all
      payment-related data entered on our pages are encrypted and sent to the
      relevant payment API.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      VUKAVI Partners<br />
      If the user accesses VUKAVI services through an offer received from a
      third party (such as their mobile network operator), we will share
      personal data about their use of VUKAVI services, such as whether and to
      what extent they used the offer, whether they activated their MEGA SLOTS
      account, or whether they are actively using VUKAVI services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We also share users' personal data in anonymized format with marketing
      partners who help us with promotions and with advertisers who allow us to
      offer free services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Compliance with Legal and Data Protection Authorities <br />When we
      believe in good faith that it is necessary to comply with applicable legal
      obligations or respond to valid legal processes (such as search warrants,
      court orders, or subpoenas), we will share users' personal data.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      If we sincerely believe that it is necessary for our legitimate interests
      or those of third parties, and for national security, law enforcement,
      litigation, criminal investigations, protection of the security of any
      person, or to prevent imminent death or bodily harm, we may also share
      users' personal data, provided that we consider that such interests do not
      outweigh the need to protect users' personal data and their fundamental
      rights and freedoms.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Business Buyers<br />
      When we sell or negotiate the sale of our business to a buyer or potential
      buyer, we will share users' personal data.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      In these cases, VUKAVI will continue to ensure the confidentiality of
      users' personal data, and we will notify users before transferring their
      personal data to the buyer or before complying with a different privacy
      policy.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      8. Retention and Deletion of Data: <br />We will retain users' personal
      data as necessary to provide VUKAVI services and for legitimate and
      necessary business purposes, such as maintaining the performance of
      VUKAVI services, making business decisions about resources and offers
      based on data, complying with our legal obligations, and resolving
      disputes. We will retain some personal data obtained from users while they
      remain users of VUKAVI services. For example, we will retain usage
      history and purchase history, profile, ranking position, credit records,
      and other account information.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      At the user's request, we will delete or anonymize their personal data so
      that the user cannot be identified, except if the law permits or requires
      the retention of certain personal data during processing, including in the
      following situations:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      If there are pending issues in the user's account, such as pending credits
      or unresolved complaints or disputes, we will retain all necessary
      personal data until the issue is resolved.<br />If we need to retain
      personal data to comply with our legal, tax, audit, and accounting
      obligations, we will retain all necessary personal data for the period
      required by applicable law.<br />
      Whenever we believe it is necessary to maintain our legitimate business
      interests, such as preventing fraud or ensuring the security of our users.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      9. Transfer to Other Countries: VUKAVI shares some of the personal data
      obtained from global users with UNITED JOY LLP, based in London, United
      Kingdom, to carry out the activities specified in this policy.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      VUKAVI may also subcontract services or share personal data obtained
      from users with third parties located in countries outside the user's
      country of residence. Therefore, the personal data obtained from users may
      be subject to privacy laws that differ from those in their country of
      residence.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      For example, personal data collected in the EU and Switzerland may be
      transferred and processed by third parties located outside the EU and
      Switzerland. In these cases, VUKAVI will ensure that the transfer of
      users' personal data complies with applicable privacy laws and, in
      particular, ensures that appropriate contractual, technical, and
      organizational measures are in place, such as the standard contractual
      clauses approved by the European Commission.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      For more information on the security measures we use to protect users'
      personal data, please refer to Section 11, "Ensuring the Security of
      Users' Personal Data."
    </p>

    <p class="m-t-10" style="line-height: 20px">
      10. URLs:<br />
      We may display third-party advertisements and other content, such as URLs
      that redirect to third-party websites. We have no control over the privacy
      practices or content of third parties and are not responsible for them. If
      users click on third-party advertisements or URLs, they should be aware
      that they will leave VUKAVI services and that any personal data they
      provide will not be subject to this policy. Users should read the relevant
      privacy policies to understand how their personal data will be collected
      and processed.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      11. Ensuring the Security of Users' Personal Data: We are committed to
      protecting users' personal data.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We have implemented technical and organizational measures to help ensure
      the security of the personal data obtained from users, such as creating
      nicknames, encryption, and access and retention policies to prevent
      unauthorized access and unnecessary retention of personal data in our
      systems. However, users should be aware that no system is completely
      secure.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Passwords can protect users' accounts, so we encourage users to use unique
      and reliable passwords, limit access to computers, browsers, and other
      devices considered secure (trustworthy), and log out after using VUKAVI
      services.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      12. Children: <br />Children Aged 13 to 18 Years<br />We recommend that
      minors over 13 years old obtain parental consent before sending any
      information about themselves over the internet.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Users may only use their account for non-commercial entertainment
      purposes. Users may not use this service for any other purpose, such as
      collecting chips from multiple accounts or in any other way. Users may not
      use their account for any illegal activity.
      <br />Users may not send repeated messages (spam), unsolicited emails,
      advertisements, or solicitations using their account. <br />Users may not
      use profane, discriminatory, or malicious language in any way, including
      in their profile picture.<br />Users may not use their account to cheat or
      hack the game. Intentionally losing to transfer chips is easily traceable,
      and this behavior will result in the confiscation of their chips and a
      ban.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      7. Users may not sublicense, rent, sell, give, transfer, or otherwise
      transfer their account or related virtual items in whole or in part to any
      person without the written permission of VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      8. Users may not purchase or acquire chips, bonuses, or any other virtual
      items from unauthorized sources (such as links from unknown sources or
      people promising free chips, etc.).
    </p>

    <p class="m-t-10" style="line-height: 20px">
      9. Each social network allows users to use the service with a single
      account. In addition, users may not use multiple accounts to try to
      accumulate free chips. This behavior can be easily detected and will
      result in the suspension and/or banning of all their accounts.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      10. Users may not exploit scripts or manual processes to abuse the
      accumulation of free chips.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      11. If a user has been excluded or banned from using the service, the user
      may not use any service or create accounts or use any accounts.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      12. If users do not agree to the terms of service, they may not use any
      game or service of VUKAVI, and the user's permission to use the service
      will be immediately revoked.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      13. Users do not have the right to:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Delete any information or content related to copyrights in the VUKAVI
      software and other copies; Reverse engineer, disassemble, decompile, or
      attempt to copy or modify the MEGA SLOTS game software for any reason;
      Use, copy, modify, link, republish, compile, publish, transmit, create
      mirror sites, or use the VUKAVI game for these purposes without prior
      consent from VUKAVI, or develop derivative products, works, or services
      related to the software.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      14. Changes to This Privacy Policy:
    </p>

    <p class="m-t-10" style="line-height: 20px">
      We may change this policy from time to time.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      When we make significant changes to this policy, we will develop
      appropriate and noticeable communications, such as displaying prominent
      notices on the MEGA SLOTS services or sending emails to users, depending
      on the circumstances. We may also communicate with users in advance.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Therefore, users should carefully read all communications.
    </p>

    <p class="m-t-10" style="line-height: 20px">15. Contact Us:</p>

    <p class="m-t-10" style="line-height: 20px">
      Thank you for reading our privacy policy. If you have any questions about
      this policy, please contact our customer support to reach our Data
      Protection Officer. We will respond in a reasonable time after verifying
      the identity of the relevant user.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      VUKAVI is responsible for processing users' personal data in accordance
      with this policy.
    </p>
    `,
  profile_title: `Account Information`,
  vip_txt: `Growth Value Required:`,
  vip_txt2: `Total Deposits:`,
  vip_txt3: `VIP Level List`,
  vip_txt4: `Level`,
  vip_txt5: `Deposit<br/> Value`,
  vip_txt6: `Upgrade<br/> Bonus`,
  vip_txt7: `Daily<br/> Rewards`,
  vip_txt8: `Monthly<br/> Bonus`,
  ResherContent_txt: `Show`,
  ResherContent_txt2: `of`,
  ResherContent_txt3: `games`,
  ResherContent_txt4: `Show More`,
  ResherContent_txt5: `No More`,
  BankInfo_txt: `Account Balance:`,
  BankInfo_txt2: `Required betting volume to reach`,
  BankInfo_txt_withdrawable: `Withdrawable Amount:`,
  BankInfo_txt3: `Still Need to Bet`,
  BankInfo_txt4: `Can Be Withdrawn`,
  BankInfo_txt5: `Standard Withdrawal`,
  BankInfo_txt6: `Add Account`,
  BankInfo_txt7: 'All',
  BankInfo_txt8: `Withdrawal Password`,
  BankInfo_txt9: `Please enter the withdrawal amount.`,
  BankInfo_txt10: `Insufficient balance for withdrawal`,
  BankInfo_txt11: `Invalid withdrawal amount range`,
  BankInfo_txt12: `Manage Account`,
  BankInfo_txt13: `Add`,
  BankInfo_txt14: `Need to upgrade to VIP3 to add more.`,
  BankInfo_txt15: `Please enter your CPF.`,
  BankInfo_txt16: `Please enter the Pix account`,
  ActivityPopup_txt: `Benefits for New Players`,
  ActivityPopup_txt2: `Register an Account`,
  ActivityPopup_txt3: `Bonus ₦3500`,
  ActivityPopup_txt4: `Bonus ₦1500`,
  ActivityPopup_txt5: `Go`,
  ActivityPopup_txt6: `Do not show again today`,
  ActivityPopup_txt7: `Never ask again`,
  login_txt: `Enter mobile number`,
  login_txt2: `Register your account`,
  login_txt3: `Login`,
  login_txt4: `Password`,
  login_txt5: `Strength`,
  login_txt6: `Confirm your password`,
  login_txt7: `I Agree`,
  login_txt8: `Terms & Privacy Policy。 `,
  login_txt9: `About Us`,
  login_txt10: `Register an Account`,
  login_txt11: `Login Now`,
  login_txt12: `Other login methods`,
  login_txt13: `'Verification successful!'`,
  login_txt14: `'Verification failed, try again'`,
  login_txt15: `'Drag the block to complete the puzzle'`,
  login_txt16: `The username cannot be less than 6 characters`,
  login_txt17: `The password must be between 6-16 characters`,
  login_txt18: `The repeated password does not match`,
  login_txt19: `Please enter the content`,
  login_txt20: `The username cannot be less than 6 characters`,
  login_txt21: `The password must be between 6-16 characters`,
  login_txt22: `I agree to the terms and privacy policy`,
  share_txt: `My link :`,
  share_txt2: `Share link via social apps`,
  share_txt3: `Agent Network`,
  share_txt4: `Total Performance 8500 Total Commission`,
  share_txt5: `225`,
  share_txt6: `Performance 5500 of Submarine`,
  share_txt7: `Commission 3% Direct Commission`,
  share_txt8: `165`,
  share_txt9: `Other's Performance 3.000`,
  share_txt10: `Level Difference 2% Other Commissions`,
  share_txt11: `60`,
  share_txt12: `<p class="f-t-16 f-w font-color2">Duration:</p>
          <p class="m-t-10 font-color">
            From now until a final date announced later.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Direct Referral Rewards:
          </p>
          <p class="m-t-10 font-color">
            During the event, for each successful referral of a valid user, the referrer will receive a direct reward of 10 , with no restrictions, and the reward can be withdrawn immediately.
          </p>
          <p class="m-t-10 font-color">
            Definition of valid user: The referred user completes a deposit.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Example:</p>
          <p class="m-t-10 font-color">
            a. User A invites B1, B2, and B3; A will receive a reward of 10 × 3 = 30 .
          </p>
          <p class="m-t-10 font-color">
            b. B1 invites C1 and C2; B1 will receive a reward of 10 × 2 = 20 .
          </p>
          <p class="m-t-10 font-color">
            c. B3 invites C3; B3 will receive a reward of 10 × 1 = 10 .
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Additional Betting Commission Bonus:
          </p>
          <p class="m-t-10 font-color">
            The referrer may also receive an additional bonus based on the effective betting value of the referred users.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Commission Rate:</p>
          <p class="m-t-10 font-color">
            If the effective betting value is between 0 and 100 , the commission rate will be 1% (that is, a reward of 1 Real for every 100  bet).
          </p>
          <p class="font-color">
            If the effective betting value exceeds 100 , the commission rate will be 3% (that is, a reward of 3  for every 100  bet).
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Assumptions:</p>
          <p class="m-t-10 font-color">
            The effective betting value for B1 is 50 ,
          </p>
          <p class="font-color">
            The effective betting value for B2 is 300 ,
          </p>
          <p class="font-color">
            The effective betting value for B3 is 20 ,
          </p>
          <p class="font-color">
            The effective betting value for C1 is 10 ,
          </p>
          <p class="font-color">
            The effective betting value for C2 is 20 ,
          </p>
          <p class="font-color">
            The effective betting value for C3 is 200 .
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            The commission is calculated as follows:
          </p>
          <p class="m-t-10 font-color">
            Commission for B1 (direct contributions from C1 and C2) = (10 + 20) × 1% = 0.3 Real.
          </p>
          <p class="font-color">
            Commission for B2 (no subordinates) = (0 + 0) × 1% = 0 Real.
          </p>
          <p class="font-color">
            Commission for B3 (direct contribution from C3) = 200 × 3% = 6 .
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Commission for A (from direct subordinates B1, B2, B3, and other subordinates C1, C2, C3):
          </p>
          <p class="m-t-10 font-color">
            (1) Direct commission for A (direct contributions from B1, B2, and B3) = (50 + 300 + 20) × 3% = 11.1 .
          </p>
          <p class="font-color">
            (2) Other commission for A (contributions from C1 and C2) = (10 + 20) × 2% = 0.6 Real.
          </p>
          <p class="font-color">
            (3) Total commission for A (direct + others) = 11.1 + 0.6 = 11.7 .
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Description of Team Structure:
          </p>
          <p class="m-t-10 font-color">
            (1) Direct team refers to the subordinates recruited directly by A, that is, the team that has a direct relationship with A.
          </p>
          <p class="font-color">
            (2) Other teams: refers to the subordinates recruited by the subordinates of A, that is, teams that do not have a direct relationship with A (such as subordinates of subordinates, subordinates of subordinates of subordinates, etc.).
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(3) Description of A:</p>
          <p class="m-t-10 font-color">
            A's direct performance is 370 , the other performance is 30  (mainly from the strong performance of C3), the total performance is 400 , and the corresponding commission rate is 370*3%+30*2% = 11.7.
          </p>
          <p class="font-color">
            Since B1's total performance is 30 , it only results in a commission rate of 1%, eliminating A's direct performance of 370 , and it results in a commission rate of 3%. The remainder is only 30 , which comes from B1. Therefore, there is a level difference of 2% between A and B1.
          </p>
          <p class="font-color">
            This difference is contributed to A by C1 and C2, that is: (10 + 20) × 2% = 0.6 Real.
          </p>
          <p class="font-color">
            There is no level difference between A and B3, so C3 does not contribute a commission to A.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(4) Description of B1:</p>
          <p class="m-t-10 font-color">
            B1 has subordinates C1 and C2, with direct performance of 30  and corresponding commission rate of 1%.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(5) Description of B2:</p>
          <p class="m-t-10 font-color">
            B2 cannot recruit subordinates and therefore has no income.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(6) Description of B3:</p>
          <p class="m-t-10 font-color">
            Although B3 joined later and is a subordinate of A, its subordinate C3 had a strong performance, with direct sales of RMB 200, allowing B3 to enjoy a high commission rate of 3% directly.
          </p>`,
  share_txt13: `VUKAVI Platform Settlement Rules`,
  share_txt14: `Referral and betting rebates are issued in real-time. Click on 'Daily Referrals' to see commission details.`,
  share_txt15: `Special Declaration:`,
  share_txt16: `To ensure fairness on the platform, anti-cheating policies are applied. Users who cheat will be permanently banned, illegally obtained funds will be frozen, and legal responsibility will be pursued.`,
  share_txt17: `Data summary`,
  share_txt18: `Subordinates`,
  share_txt19: `direct`,
  share_txt20: `Number of deposits`,
  share_txt21: `for the first time`,
  share_txt22: `The value of `,
  share_txt23: `first deposit`,
  share_txt24: `Total claims of`,
  share_txt25: `direct subs`,
  share_txt26: `Total valid bets`,
  share_txt27: `valid bets of direct sub`,
  share_txt28: `<p>New<br/> subordinates</p>`,
  share_txt29: `<p>Value of the first <br/>deposit</p>`,
  share_txt30: `<p>Number of <br/>players of the<br/>first deposit</p>`,
  share_txt31: `<p>Deposit value</p>`,
  share_txt32: `<p>Number of <br/>deposits</p>`,
  share_txt33: `<p>Valid Bets</p>`,
  share_txt34: `Deposit amount: `,
  share_txt35: `Status: `,
  share_txt36: `His subordinates: `,
  share_txt37: `Valid Bets: `,
  share_txt38: `Login date: `,
  LuckyRoulette_txt: `Win`,
  LuckyRoulette_txt2: `Claim`,
  LuckyRoulette_txt3: `Reset deposits`,
  LuckyRoulette_txt4: `Win ≥ 100 to reclaim`,
  LuckyRoulette_txt5: `tie times`,
  LuckyRoulette_txt6: `remaining`,
  LuckyRoulette_txt7: `Promote 10 subordinates to get 1 chance of tie`,
  LuckyRoulette_txt8: `Share`,
  LuckyRoulette_txt9: `The successful login of the promoted subordinate is considered
                  valid, currently`,
  LuckyRoulette_txt10: `people are valid`,
  LuckyRoulette_txt11: `
                      <p class="m-t-10">
                        1. During the activity period, each member can
                        win 1 carousel lottery opportunity, and he can
                        win up to 15,000 in bonus.
                      </p>
                      <p class="m-t-10">
                        2. After completing the corresponding task, you can
                        obtain 1 lottery opportunity. After the number of lottery
                        chances is used, you can continue to complete the task
                        and obtain 1 lottery opportunity;
                      </p>
                      <p class="m-t-10">
                        3. Reset rewards daily, complete missions to claim;
                      </p>
                      <p class="m-t-10">
                        4. The winner of rewards can only be manually claimed
                        on the NPC Android_H5, iOS_H5, Android_app, iOS_app
                        platforms;
                      </p>
                      <p class="m-t-10">
                        5. After 1 day ATT and the end of each cycle, the
                        received rewards expire and are directly canceled;
                      </p>
                      <p class="m-t-10">
                        6. The bonus (excluding capital) granted in this event
                        requires 1 time of valid bets to be withdrawn. The bet
                        is not limited to gaming platforms;
                      </p>
                      <p class="m-t-10">
                        7. This event is only for normal manual operations by
                        the account owner, and the use of cheating software,
                        bots, gambling between different accounts, mutual
                        manipulation, arbitrage, APIs, protocols, exploiting
                        vulnerabilities, group control, or other technical means
                        is prohibited, otherwise, the rewards may be canceled
                        or deducted, or the accounts may be frozen or even
                        blacklisted;
                      </p>
                      <p class="m-t-10">
                        8. To avoid divergence in understanding the text, the
                        platform reserves the right to the final interpretation
                        of this event.
                      </p>`,
  LuckyRoulette_txt12: `Congratulations on winning`,
  LuckyRoulette_txt13: `, which can be withdrawn for only`,
  LuckyRoulette_txt14: `. Invite`,
  LuckyRoulette_txt15: `friends to complete the registration to help you, and you can claim it when you spend`,
  RechargeCont_txt: `Deposit Record`,
  RechargeCont_txt2: `Online Deposit`,
  RechargeCont_txt3: `Members can only receive the corresponding bonuses after depositing the recommended amount. The additional bonus and deposit bonus can be accumulated and offered`,
  RechargeCont_txt4: `Bonus can be redeemed after 1x billing`,
  RechargeCont_txt5: `Details of the bonus event`,
  RechargeCont_txt6: `First deposit, the minimum value for the gift is`,
  RechargeCont_txt7: `Deposits can get up to 10% bonus.`,
  RechargeCont_txt8: `Incorrect deposit value range.`,
  common_txt: `Current Level`,
  common_txt2: `Promotion Criteria`,
  common_txt3: `Required Deposit:`,
  common_txt4: `List of VIP Levels`,
  common_txt5: `VIP Details`,
  common_txt6: `In progress`,
  common_txt7: `phone number`,
  common_txt8: `password`,
  common_txt9: `confirm password`,
  common_txt10: `Treasure`,
  common_txt11: `Offers`,
  common_txt12: `Rebate`,
  common_txt13: `Collection`,
  common_txt14: `Super`,
  common_txt15: `Redeem`,
  common_txt16: `Roulette`,
  common_txt17: `Agent`,
  common_txt18: `Level`,
  common_txt19: `Mysterious`,
  common_txt20: `Bonus`,
  common_txt21: `Customer Service Center`,
  common_txt22: `Contact`,
  common_txt23: `Support`,
  common_txt24: `<p class="m-b-5 f-t-15">Dear User</p>
      <div>
        1. Members with VIP1 or higher level can withdraw the entire balance in
        their account at one time.<br />
        <p class="m-t-10">
          2. There is no limit to the number of withdrawals per day, and
          VUKAVI supports 24-hour online withdrawals.
        </p>
        <p class="m-t-10">
          3. The minimum amount for a single withdrawal is 1000 .
          Withdrawal requests cannot be initiated for amounts less than this.
        </p>
        <p class="m-t-10">
          4. Each user can only initiate one withdrawal request at a time. A new
          withdrawal request can be initiated only after the previous one has
          been processed.
        </p>
        <p class="m-t-10">
          5. Usually, your withdrawal will arrive in your bank account within 1
          minute. If you do not receive the withdrawal amount for a long time,
          please contact customer service for assistance.
        </p></div>
        `,
  common_txt25: `VUKAVI is an online gaming brand. Please play responsibly. 18+`,
  common_txt26: `Commission`,
  common_txt27: `How To Invite`,
  common_txt28: `My Data`,
  common_txt29: `Subordinate Details`,
  common_txt30: `
        <div>
          <p class="m-t-10">
            1. The recharge bonus can increase your gambling principal. Of
            course, you have the right to choose to forgo the bonus and continue
            recharging.
          </p>
          <p class="m-t-10">
            2. The recharge bonus requires 1 valid game betting record before a
            withdrawal application can be initiated.
          </p>
          <p class="m-t-10">
            3. After the payment is completed, the amount paid will be displayed
            in the game wallet. If you do not receive the recharge amount in
            time, please contact the online customer service for help.
          </p>
        </div> `,
  common_txt31: `Credit Score Details`,
  common_txt32: `CP Rules`,
  common_txt33: ` Initial Credit Score: Your account starts with a 100-point credit score.
        When you modify sensitive information (such as your real name,
        withdrawal password, or bank account) or repeatedly attempt incorrect
        withdrawals, the system will deduct corresponding points to protect your
        account security. Withdrawal Restrictions: If your credit score falls
        below 90 points, your withdrawal privileges will be restricted. To
        restore your score, you must either: Make a new deposit, or Upgrade your
        VIP level. (Note: This ensures account safety and prevents fraudulent
        activities.)`,
  common_txt34: `Unlimited development of subordinates`,
  common_txt35: `Activity Description`,
  common_txt36: `<p class="m-b-10">
          Settlement time: The system will settle the commission of the previous
          day at 00:00 the next day.
        </p>
        <p class="m-b-10">
          Invite your friends to join the game through different ways: through
          our website Facebook /Instagram/TikTok /Telegram /WhatsApp /YouTube,
          etc. Hurry up and invite all members whoregistered through your unique
          link to becomeyour direct agents, but please note that the newmembers
          you invite must be real and valid.
        </p>
        <p class="m-b-10">Main advantages:</p>
        <p class="m-b-10">
          1. Get invitation bonuses and high commissions lfyour first deposit is
          successful, you can get abonus of 3,000. For example, if you invite
          10people to make their first deposit, you can earn30,000.The more
          people you invite, the morebonuses you get. You can check your history
          onthe promotion page.
        </p>
        <p class="m-b-10">
          2. lf your guests bet #1 or more, you can alreadyenjoy high
          commissions! You can earn up to 5%lifetime commission, which is a
          lifetime invitation!For example: You have 100 offline members, andthe
          total actual daily bets are estimated to be 300million.The commission
          you receive every day is:300,000x2%=6,000.Itis super easy toearn
          commissions every month.
        </p>`,
  common_txt37: `Roulette`,
  common_txt38: `Share`,
  common_txt39: `Treasure`,
  common_txt40: `Red envelope`,
  common_txt41: `Rescue`,
  common_txt42: `Game record`,
  common_txt43: `Registration`,
  common_txt44: `Wallet details`,
  common_txt45: `Credit score`,
  common_txt46: `Real Name`,
  common_txt47: `Card Number`,
  common_txt48: `Level`,
  common_txt49: `Team Betting`,
  common_txt50: `Ratino`,
  common_txt51: `Gain`,
  common_txt52: `Rules`,
  common_txt53: `Win ≥`,
  common_txt54: `to claim.`,
  common_txt55: `Balance:`,
  common_txt56: `copy`,
  common_txt57: `My link:`,
  common_txt58: `Quick Sharing`,
  common_txt59: `Payment method：`,
  common_txt60: `ALL`,
  common_txt61: `more`,
  common_txt62: `Lobby`,
  common_txt63: `Game Category`,
  common_txt64: `install`,
  common_txt65: `Wrong number`,
  common_txt66: `Credit Score`,
  common_txt67: `Loading`,
  common_txt68: `in order to be able to withdraw`,
  common_txt69: `Lotto Result:`,
  common_txt70: `Gameplay`,
  common_txt71: `Quick pick`,
  common_txt72: `A total of`,
  common_txt73: `bets`,
  common_txt74: `Price`,
  common_txt75: `A single bet can bewon`,
  common_txt76: `bet`,
  common_txt77: `Lottery Order`,
  common_txt78: `Empty`,
  common_txt79: `Bet type`,
  common_txt80: `Instructions`,
  common_txt81: `Today's betting`,
  common_txt82: `Results`,
  common_txt83: `Select at least `,
  common_txt84: ` numbers.`,
  common_txt85: `Max Winper Balls`,
  common_txt86: `Amount`,
  common_txt87: `Money:`,
  common_txt88: `Lines`,
  common_txt89: `Selected:`,
  common_txt90: `Total:`,
  common_txt91: `Balance:`,
  common_txt92: `Bet`,
  common_txt93: `You haven’t placed an order yet.`,
  common_txt94: `To participate, you can mark between 2 to 6 clovers.`,
  common_txt95: `Your bet amount exceeds your balance.`,
  common_txt96: `Please choose two lucky numbers.`,
  common_txt97: `Select at least one number from each column.`,
  common_txt98: `Choose your lucky month. In every contest, a month is drawn.`,
  common_txt99: `January`,
  common_txt100: `February`,
  common_txt101: `March`,
  common_txt102: `April`,
  common_txt103: `May`,
  common_txt104: `June`,
  common_txt105: `July`,
  common_txt106: `August`,
  common_txt107: `September`,
  common_txt108: `October`,
  common_txt109: `November`,
  common_txt110: `December`,
  common_txt111: `Choose at least one lucky month.`,
  common_txt112: `Please select your numbers.`,
  common_txt113: `The minimum bet is `,
  common_txt114: `Please select.`,
  common_txt115: `Amount:`,
  common_txt116: `Betting Details`,
  common_txt117: `Program Information`,
  common_txt118: `Bet Amount:`,
  common_txt119: `Betting Time:`,
  common_txt120: `Order Number:`,
  common_txt121: `Program Content`,
  common_txt122: `Odds:`,
  common_txt123: `times`,
  common_txt124: `dose、a total of`,
  common_txt125: `doses.`,
  common_txt126: `CONTINUE BETTING`,
  common_txt127: `REVOKE`,
  common_txt128: `Today's Betting`,
  common_txt129: `Bet History`,
  common_txt130: `Oops! No data yet!`,
  common_txt131: `Unsettled`,
  common_txt132: `Settled`,
  common_txt133: `Bonus`,
  common_txt134: `Loss`,
  common_txt135: `Latest Results`,
  common_txt136: `Latest results:`,
  common_txt137: `Machine code:`,
  common_txt138: `Lottery`,
  common_txt139: `Cassino`,
  common_txt140: `Joln Telegram`,
  common_txt141: `Team commissions`,
  common_txt142: `Data summary`,
  common_txt143: `Recharge amount`,
  common_txt144: `Search games`,
  common_txt145: `No Games`,
  common_txt146: `Search`,
  common_txt147: `Playing on TheLotter`,
  common_txt148: `How does it work?`,
  common_txt149: `You Play`,
  common_txt150: `Select the lottery you wish to play and fill out your entries with your favorite numbers.`,
  common_txt151: `We Buy`,
  common_txt152: `We'll buy official tickets on your behalf from a licensed retailerand scan them into your safe andsecure private account.`,
  common_txt153: `You Win`,
  common_txt154: `We'll notify you when you winand transfer your prizes to youcommission-free`,
  common_txt155: `The bonus money for free collection is only supported for PG electronic games.`,
  common_txt156: `Dear player,Our system has detected that your VIP level is currently low. For the security of your funds, your gaming features have been temporarily disabled. Please complete a successful withdrawal first, then recharge to restore full gaming functionality.`,
  common_txt157: `Insufficient balance, please recharge and continue.`,
  common_txt158: `Please make the first deposit.`,
  common_txt159: `The game developer is performing maintenance on the game, please try again later.`,
  common_txt160: `The functionality of the game has been disabled. Please contact online support for assistance.`,
  common_txt161: `Are you sure you want to cancel the order?`,
  common_txt162: `Draw`,
  common_txt163: `Order`,
  common_txt164: `VUKAVI is an agent of Golden Chance Lotto and a company operating in the lottery business. All lottery products offered on the platform are provided by Golden Chance Lotto and processed by VUKAVI's official agents.`,
  common_txt165: `Share on Social Media`,
  common_txt166: `Accepted payment methods:`,
  common_txt167: `cards and cryptocurrency.`, // 修正拼写错误 "Cartöes" 为 "Cartões"，按巴西支付习惯保留 PIX 大写
  common_txt168: `Lotteries`,
  common_txt169: `Lotteries`, // 巴西联邦储蓄银行官方译名
  common_txt170: `MILLIONS`,
  common_txt171: `Grand Prize`,
  common_txt172: `They won the grand prize`,
  common_txt173: `Prizes distributed`,
  common_txt174: `account`,
  common_txt175: `lottery`,
  common_txt176: `prize`,
  common_txt177: `Check the latest lottery results`, // 修正语法错误 "resultadosdas" 为 "resultados das"
  common_txt178: `Buy`,
  common_txt179: `Draw held at ESPAÇO DA SORTE in SÃO`,
  common_txt180: `PAULO, SP`, // 保留巴西城市名官方拼写（含重音）
  common_txt181: `validate`,
  common_txt182: `1st draw`,
  common_txt183: `2nd draw`,
  common_txt184: `Check the Quina result`, // Quina 为巴西专属彩票玩法，保留原名
  common_txt185: `VUKAVI is an agent of Golden Chance Lotto and a company operating in the
          lottery business. All lottery products offered on the platform are
          provided by Golden Chance Lotto and processed by VUKAVI's official agents.`,
  common_txt186: `Share on Social Media`,
  common_txt187: `Accepted payment methods:`,
  common_txt188: `Credit cards, PIX and PicPay.`, // 与 167 保持一致
  common_txt189: `All`,
  common_txt190: `number`,
  common_txt191: `currency`,
  common_txt192: `Day`,
  common_txt193: `Bet History`, // 彩票行业常用表述
  common_txt194: `Drawn`,
  common_txt195: `Not Drawn`,
  common_txt196: `Bet time`,
  common_txt197: `amount`,
  common_txt198: `Total Prize`,
  common_txt199: `Non-winning`,
  common_txt200: `Prize cancelled`,
  common_txt201: `Won`,
  common_txt202: `System cancellation`,
  common_txt203: `To be drawn`,
  common_txt204: `win`,
  common_txt205: `times,`,
  common_txt206: `bets, totaling`, // 更符合英语表达习惯
  common_txt207: `Bet now`,
  common_txt208: `Bet Closure`, // 彩票行业标准术语
  common_txt209: `lottery edition`,
  common_txt210: `the previous edition:`,
  common_txt211: `th row`, // 序数词规范表达（如 3ª fila → 3rd row）
  common_txt212: `Currently, the system does not support betting on different
          lotteries in a single bet. If you proceed, your cart will be cleared!`,
  common_txt213: `continue`,
  common_txt214: `Betting for the current lottery round has closed and the new round is now open.`,
  common_txt215: `I am over 18 years of age and have read and accepted the Terms of Service and Privacy Policy.`, // 修正拼写错误 "eaceitei" 为 "aceitei"，补充 "have" 符合语法
  common_txt216: `Yes, I want to receive exclusive offers and discounts!`, // 修正换行格式
  common_txt217: `Draw No.`, // 彩票行业常用缩写
  common_txt218: `Amount`,
  common_txt219: `Status`,
  common_txt220: `Prize`,
  common_txt221: `1. There is no limit to the number of withdrawals per day, and VUKAVI offers
          24/7 online withdrawal support.`, // 优化表达使其更自然
  common_txt222: `2. The minimum amount for a single withdrawal is`,
  common_txt223: `. Withdrawal requests for amounts below this cannot be initiated.`,
  common_txt224: `3. Each user can only initiate one withdrawal request at a time. A new withdrawal request
          can only be made after the previous one has been processed.`,
  common_txt225: `4. Normally, your withdrawal will be credited to your bank account within 1 minute.
          If you do not receive the withdrawal amount after a long period, please
          contact customer support for assistance.`,
  common_txt226: `Total Spent:`,
  common_txt227: `Total Prize:`,
  common_txt228: `REFUND<br/>FOR GAME LOSS`,
  common_txt229: `CASHBACK UP TO 50%`,
  common_txt230: `FREE SPIN`,
  common_txt231: `LOG IN TO <br/>RECEIVE EXTRA <br/>REWARDS`,
  common_txt232: `OPEN YOUR<br/>LUCKY BOX`,
  common_txt233: `THE MAXIMUM PRIZE<br/>CAN REACH UP TO`,
  common_txt234: `VIP MEMBER`,
  common_txt235: `VIP UPGRADE PRIZE<br/>MONTHLY VIP PRIZE<br/>MORE ABUNDANT VIP PRIZES`,
  common_txt236: `DAILY<br/>CASH PACK<br/>SHOWER`,
  common_txt237: ``,
  common_txt238: `DEPOSIT BONUS`,
  common_txt239: `THE MORE<br/>ACCUMULATED DEPOSITS,<br/>THE BIGGER THE SURPRISES`,
  common_txt240: `TEAM BET<br/>PRIZE`,
  common_txt241: `YOUR TEAM WILL RECEIVE <br/>A WEEKLY <br/>CASHBACK REWARD`,
  common_txt242: `INVITATION<br/>COMMISSION`,
  common_txt243: `THE MORE PEOPLE YOU<br/>INVITE, THE BIGGER THE BONUS`,
  common_txt244: `VIP MEMBER`,
  common_txt245: `Daily VIP access and check-in<br/>guarantee generous<br/>rewards`,
  common_txt246: `Choose to connect to the network:`,
  common_txt247: `Receive in Nigerian `,
  common_txt248: `Pay Countdown`,
  common_txt249: `Deposit Address`,
  common_txt250: `Copy Address`,
  common_txt251: `Payment Successful`,
  common_txt252: `Payment Timeout`,
  common_txt253: `1.Please complete the payment before the order countdown expires.`,
  common_txt254: `2.You can obtain the wallet address by scanning the QR code or copying it.`,
  common_txt255: `3.Please select the correct network when making the payment.`,
  common_txt256: `Records`,
  common_txt257: `Payment channel is  available.`,
  common_txt258: `Edit`,
  common_txt259: `Account Balance`,
  common_txt260: `Withdrawal Records`,
  common_txt261: `Game Records`,
  common_txt262: `Email`,
  common_txt263: `My Collection Games`,
  common_txt264: `Help & FAQ`,
  common_txt265: `Business Partners`,
  common_txt266: `Online Customer Service`,
  common_txt267: `Start to log in VUKAVI`,
  common_txt268: `Start to Register VUKAVI`,
  common_txt269: `Create account`,
  common_txt270: `Already have an account?`,
  common_txt271: `Agree or disagree with the Service Policy and Privacy Policy`,
  common_txt272: `Please select country`,
  common_txt273: `Please make sure the country you selected is correct!`,
  common_txt274: `- PLAYER SUPPORT -`,
  common_txt275: `(Click on the icon below to contact customer service)`,
  common_txt276: `24/7 Online Support`,
  common_txt277: `Online Customer Service`,
  common_txt278: `Wonderful Activities`,
  common_txt279: `Join Our Community`,
  common_txt280: `Social Media Groups& Channels`,
  common_txt281: `My Collection Games`,
  common_txt282: `Help & FAQ`,
  common_txt283: `Live Support`,
  common_txt284: `Cash Coupon`,
  common_txt285: `Business Partners`,
  common_txt286: `Business Contacts :`,
  common_txt287: `Join Our Community`,
  common_txt288: `My Collection Games `,
  common_txt289: `Help & FAQ`,
  common_txt290: `Business Partners`,
  common_txt291: `Online Customer Service`,
  common_txt292: `Change your password`,
  common_txt293: `Mail Box`,
  common_txt294: `Welcome to VUKAVI`,
  common_txt295: `Content:Welcome to <span style='color:#ff8b2d'>VUKAVI</span>!`,
  common_txt296: `My Collcetion Games`,
  common_txt297: `Commom problems`,
  common_txt298: `How to Play Game?`,
  common_txt299: `
            1. Sign up by your own phone number.<br>
            2. Deposit to play the games you want to play.<br>
            3. After deposit successful, you can choose games you like and bet to play. If you do not know how to play the game or how the games work, you can try demo first.
          `,
  common_txt300: `How to Deposit?`,
  common_txt301: `
            After Registering, you can click Deposit moving to the deposit page. Then you can choose the amount you want to deposit or enter the amount you want.Please pay attention to the minimum deposit.
          `,
  common_txt302: `How to Withdraw?`,
  common_txt303: `
            Withdraw is easy and fast. Click the withdraw button,follow steps, make sure your withdraw account information is correct.<br>
            -Pay attention to withdraw tips below withdraw page.<br>
            -Different countries have different minimum withdraw amount.<br>
            -If you see the withdrawal has ×100, then multiply it by 100, that means if you want to withdraw 30.00, then just input number 300.
          `,
  common_txt304: `How to Get Promotion Bonus?`,
  common_txt305: `
            Thanks for joining in our promotion program. First, you should know that if you only invite friends to register or share your referral to others there is no bonus. Second, if you want win cash bonus, you can invite or encourage them to play games, once they deposit to play games, you will get your bonus. How much you get depends on how much they deposit to play.
          `,
  common_txt306: `Deposit and Withdraw Failed?`,
  common_txt307: `
            Deposit failed: please keep you payment transaction message as the proof, and then contact our Online Game Support below.<br>
            Withdrawal failed and pending:<br>
            -Due to Network problem or withdrawal account information error: your withdrawal will fail. But do not worry, you can check your network and information, then withdrawal again.<br>
            -Withdrawal Pending: usually this problem is caused by the payment system please wait a few minutes.
          `,
  common_txt308: `Select amount below`,
  common_txt309: `VIP Discount>>`,
  common_txt310: `Get`,
  common_txt311: `The minimum amount`,
  common_txt312: `Deposit Priviles`,
  common_txt313: `Actual amount received:`,
  common_txt314: `Pay`,
  common_txt315: `-- CONTACT CUSTOMER SERVICE --`,
  common_txt316: `*If payment fails or there is a problem with the payment method,please contact customer service.`,
  common_txt317: `Deposit Tips`,
  common_txt318: `Withdrawal Instructions`,
  common_txt319: `Get for free`,
  common_txt320: `You can get bonus by participating to invite friends to register and play games. Whether you complete the Event or not, you can get cash rewards in the end.`,
  common_txt321: `Count Down`,
  common_txt322: `Invites Details`,
  common_txt323: `Code`,
  common_txt324: `Time`,
  common_txt325: `Invitee Count`,
  common_txt326: `--- No other data is available! ---`,
  common_txt327: `Event Rules`,
  common_txt328: `Alliance`,
  common_txt329: `Account Information`,
  common_txt330: `Total number of people`,
  common_txt331: `Total Recharge`,
  common_txt332: `New Recharge`,
  common_txt333: `New Recharge Count`,
  common_txt334: `View all commission tiers`,
  common_txt335: `Commission Level`,
  common_txt336: `Monthly Bonus`,
  common_txt337: `Recharge Amount`,
  common_txt338: `Share with your social community`,
  common_txt339: `Share this referral link with your friends.`,
  common_txt340: `Copy`,
  common_txt341: `Today's Agent Rebate Display`,
  common_txt342: `Rebate level`,
  common_txt343: `Direct Rebate`,
  common_txt344: `Team Rebate`,
  common_txt345: `Direct Rebate  %`,
  common_txt346: `Direct Net Profit`,
  common_txt347: `Direct Rebate`,
  common_txt348: `Team Rebate %`,
  common_txt349: `Team Net Profit`,
  common_txt350: `Team Rebate`,
  common_txt351: `Note:<br />
              The rebate amount (1000) can be claimed after 00:30.
              <p style="color: #8c8c8c">
                1.A: Direct users are players invited by you.
              </p>
              <p style="color: #8c8c8c">
                2.B: Team users are players invited by your direct users.
              </p>`,
  common_txt352: `Direct Rebate %`,
  common_txt353: `Team Rebate %`,
  common_txt354: `Rebate Amount`,
  common_txt355: `Claimable Amount`,
  common_txt356: `Get Cash`,
  common_txt357: 'Sweet Notice: Hello, dear player! If you have any little trouble with deposits or withdrawals, contact our online support right away! We\'re here to help you with lots of love, care and speed — all to make your experience light, happy and stress-free!\nUNMISSABLE SUPER PROMOTION!\nJoin the super prize box promotion! Invite 1 friend and get 50. Win up to 500,000 easily!\nGet an exclusive 5% commission when inviting friends! Earn up to 1,000,000 per month simply and safely!\nAmazing surprises!\nRegister on VUKAVI now and enjoy unmissable bonuses!\nCheck-in: Consecutively and get 888 Bonus up to 9,999! Up to 12 times a day!\nDistribution times: 23:00 - 23:59 · 00:00 - 00:59 · 01:00 - 01:59 · 02:00 - 02:59 · 03:00 - 03:59 · 04:00 - 04:59 · 05:00 - 05:59 · 06:00 - 06:59 · 07:00 - 07:59 · 08:00 - 08:59 · 10:00 - 10:59 · 11:00 - 11:59\nReliable platform, fast deposits and withdrawals!\nJoin VUKAVI now and start your journey to wealth!\nVUKAVI - The largest and most trusted online casino!\nHigh winning probability on PG games, continuous promotions and wealth within your reach!\nThe best slot machines, endless fun and guaranteed excitement!\nFairness and transparency, official license and guaranteed reliability!\nSafe and stable, no worries about deposits and withdrawals!\nRegister now and start your journey to make money!',
  common_txt358: `Join Our Community`,
  common_txt359: `Social Media Groups& Channels`,
  common_txt360: `COOPERATIVE`,
  common_txt361: `This game is only for people over the age of 18 years.Gambling may have adverse  effects if not taken in moderation.`,
  common_txt362: `You can only use your registered number to add credit to your wallet; if it is incorrect, please register again with your correct Mobile Money number.`,
  common_txt363: `Payment Confirmation`,
  common_txt364: `Please enter the 6-digit verification code.`,
  common_txt365: `1.To generate a temporary code, open the Orange Money Africa app and
            click "Generate OTP", or dial `,
  common_txt366: `Important note: Ensure the OTP you receive shows an amount of`,
  common_txt367: `, otherwise the payment will not be successful.`,
  common_txt368: ` (click to dial) and
            listen to the call.<br />
            2.Enter your generated verification code here.<br />
            3.Please enter the verification code received via SMS.<br />`,
  common_txt369: `The account number must consist of 8 to 13 digits only.`,
  common_txt370: `To complete the payment with `,
  common_txt371: `<span class="info-color">Step 1: </span> Confirm that you want to proceed, then enter your payment PIN to authorize the transaction.`,
  common_txt372: `<span class="info-color">Step 2: </span> Wait for the payment to be completed.`,
  common_txt373: `Close this window and try again if the system rejects it due to a network error.`,
  common_txt374: ` , follow these steps:`,
  common_txt375: `Cannot be less than 6 characters`,
  common_txt376: `The number must be 8-11 digits and cannot start with 0.`,
  tab_menu: 'Menu',
  tab_promotions: 'Promotions',
  activity_tab: 'Promotions',
  activity_new: 'New',
  activity_events: 'Events',
  activity_season_pass: 'Season Pass',
  activity_season_pass_desc: 'Unlock exclusive premium tiers',
  activity_limited_offers: 'Limited Offers',
  activity_more_events: 'More Events',
  activity_active: 'Active',
  activity_welcome_bonus: 'Welcome Bonus',
  activity_welcome_bonus_desc: '100% Match up to $200',
  activity_first_deposit_chest: 'First Deposit Chest',
  activity_first_deposit_chest_desc: 'Instant unlock',
  activity_super_value: 'Super Value Packs',
  activity_super_value_desc: '50% extra value',
  activity_lucky_spin: 'Lucky Spin',
  activity_lucky_spin_desc: 'Free spin every 12 hours',
  activity_weekly_missions: 'Weekly Missions',
  activity_weekly_missions_desc: 'Complete missions for rewards',
  activity_red_envelope: 'Red Envelope Rain',
  activity_red_envelope_desc: 'Grab cash prizes',
  activity_spin: 'Spin',
  activity_view: 'View',
  activity_join: 'Join',
  activity_vip: 'VIP',
  activity_daily_checkin: 'Daily Check-in',
  activity_daily_checkin_desc: 'You can get sign-in rewards by logging into the game every day, and you can get more after depositing.',
  activity_checkin_title: 'Check-in',
  activity_register_checkin: 'Register Check-in',
  activity_deposit_checkin: 'Deposit Check-in',
  activity_premium_tip: 'Premium rewards are unlocked after daily payment',
  activity_deposit_required: 'Please deposit first to unlock premium rewards',
  activity_checkin_success: 'Check-in successful!',
  activity_already_checked: 'Already checked in today',
  activity_coming_soon: 'Coming Soon',
  activity_stay_tuned: 'Stay tuned, something amazing is coming!',
  activity_invite_earn: 'Invite & Earn',
  activity_invite_earn_desc: 'Invite friends to complete registration and deposit tasks to earn cash rewards. Repeatable!',
  activity_cash_rain: 'Cash Rain',
  activity_cash_rain_desc: 'Deposit players click every day to compete for cash prizes.',
  activity_details: 'Details',
  activity_invite_now: 'Invite Now',
  activity_day: 'Day',
  activity_checkin_btn: 'Check In',
  activity_rules: 'Rules',
  activity_rule1: '1. Sign in every day to receive rewards, sign-in resets weekly.',
  activity_rule2: '2. Register users can claim basic rewards.',
  activity_rule3: '3. Deposit users unlock premium rewards with higher amounts.',
  activity_rule4: '4. Missed days cannot be retroactively signed.',
  reward_history: 'Reward History',
  reward_regular_signin: 'Regular Sign-in',
  reward_deposit_signin: 'Deposit Sign-in',
  reward_premium: 'PREMIUM',
  reward_select_date: 'Select Date',
  reward_confirm: 'Confirm Selection',
  reward_cancel: 'Cancel',
  reward_go_deposit: 'Go To Deposit',
  reward_your_rewards: 'Your Rewards',
  reward_claimed: 'CLAIMED',
  reward_locked: 'LOCKED',
  reward_claim_coins: 'CLAIM',
  season_pass_title: 'Season Pass',
  season_current_progress: 'Current Progress',
  season_next_reward: 'Next Reward',
  season_upgrade_pass: 'UPGRADE PASS',
  season_unlock_premium: 'Unlock Premium Tiers',
  season_junior: 'Junior',
  season_senior: 'Senior',
  season_junior_desc: 'Silver rewards & standard XP boosts',
  season_senior_desc: 'Gold items & max XP multipliers',
  season_unlock_junior: 'Unlock Junior',
  season_go_senior: 'Go Senior Pro',
  season_reward_track: 'Reward Track',
  season_points: 'Points',
  season_basic: 'Basic',
  season_claimed: 'CLAIMED',
  season_claim: 'Claim',
  season_locked: 'LOCKED',
  season_history_title: 'Season History',
  season_history_current: 'CURRENT',
  season_history_target: 'Target',
  season_history_view_current: 'View Current Season',
  season_history_past: 'Past Seasons',
  season_history_completed: 'COMPLETED',
  season_history_expired: 'EXPIRED',
  season_history_empty: 'No past seasons yet',
  lr_target_reward: 'Target Reward',
  lr_current_earnings: 'Current Earnings',
  lr_spins_hint: 'Claim all rewards once the progress bar is fully filled.',
  lr_claim_reward: 'Claim Reward',
  lr_spinning: 'SPINNING...',
  lr_referral_link: 'Your Referral Link',
  lr_copy: 'Copy',
  lr_rules_highlight: 'Get 3 FREE spins!',
  lr_rules_desc: 'Invite friends to register (Email/Phone verified) to earn more spins. Reach the target to claim your cash!',
  lr_recent_winners: 'Recent Winners',
  lr_player_name: 'Player Name',
  lr_reward_amount: 'Reward Amount',
  lr_insufficient_spins: 'Insufficient Spins',
  lr_invite_more: 'Invite friends to register and earn more spins immediately!',
  lr_close: 'Close',
  ng_title: 'Newbie Exclusive Gift',
  ng_limited_time: 'Limited Time Remaining',
  ng_limited_price: 'Limited Price',
  ng_buy_now: 'Buy Now',
  ng_claim: 'Claim',
  ng_claimed: 'Claimed',
  ng_disclaimer: 'Limited to one purchase per user. Terms and conditions apply.',
  ng_total_reward: 'Total 3-Day Reward',
  ng_day1_title: 'Day 1 Reward',
  ng_day1_desc: 'Get <span class="highlight">100% Deposit Bonus</span> + Day 1 Pack + <span class="highlight">Extra 100 Coins</span>',
  ng_day2_title: 'Day 2 Reward',
  ng_day2_desc: 'Return tomorrow for <span class="highlight">Extra 200 Coins</span>',
  ng_day3_title: 'Final Big Reward',
  ng_day3_desc: 'Unlock massive mystery prize: <span class="highlight">Extra 500 Coins</span>',
  fd_title: 'First Deposit Gift',
  fd_title_short: 'First Deposit',
  fd_gift: 'Gift',
  fd_exclusive_offer: 'Exclusive Offer',
  fd_total_value: 'Total Value',
  fd_premium_bundle: 'Premium Rewards Bundle',
  fd_energy_expires: 'Offer expires when energy runs out',
  fd_limit: 'LIMIT:',
  fd_value: 'Value',
  fd_quick_deposit: 'Quick Deposit',
  fd_return_300: 'Total Value 300% Return!',
  fd_limited_one: 'Limited to one purchase per user.',
  fd_mission_briefing: 'Mission Briefing',
  fd_total_reward_value: 'Total Reward Value',
  fd_critical_deadline: 'Critical Deadline',
  fd_energy_critical: 'Energy Level: Critical Status',
  fd_claim_now: 'Claim Now',
  fd_offer_ends_energy: 'Offer ends when energy runs out',
  tb_treasure_box: 'Treasure',
  tb_box: 'Box',
  fr_title_short: 'First Deposit',
  fr_bonus: 'Bonus',
  fr_recharge_now: 'Take the leap → Deposit now',
  fr_up_to_prefix: 'Receive up to',
  fr_up_to_suffix: 'rewards.',
  fr_limited_offer: 'Limited Time Offer',
  fr_next_unlock: 'Next Unlock',
  fr_day: 'Day',
  fr_claimed: 'Claimed',
  fr_locked: 'Locked',
  fr_daily_hint: 'Return each day to claim your reward.',
  mc_title: 'Mission Center',
  mc_daily: 'Daily',
  mc_newbie: 'Newbie',
  mc_weekly: 'Weekly',
  mc_activity_points: 'Activity Points',
  mc_reset_in: 'Reset in',
  mc_todays_missions: "Today's Missions",
  mc_newbie_missions: 'Newbie Missions',
  mc_weekly_missions: 'Weekly Missions',
  mc_claim: 'Claim',
  mc_claimed: 'Claimed',
  mc_go: 'Go',
  mc_pts: 'Pts',
  mc_claim_failed: 'Claim failed',
  mc_claim_unavailable: 'Reward is temporarily unavailable. Please try again later.',
  mc_locked_title: 'Locked',
  mc_locked_desc: 'Complete all newbie missions to unlock.',
  mc_go_newbie: 'Go to Newbie Missions',
  mc_request_failed: 'Mission request failed. Please try again later.',
  mc_rules_title: 'Activity Rules',
  mc_rule_1: 'Players will be given a list of simple daily missions upon logging in.',
  mc_rule_2: 'Complete a mission to receive the daily reward and accumulate activity points.',
  mc_rule_3: 'Reach specific point milestones to unlock additional bonus rewards.',
  mc_rule_4: 'Complete all missions to claim the grand final prize.',
  profile_account_name: 'Account Name',
  profile_real_name: 'Real Name Authentication',
  profile_login_pass: 'Change Login Password',
  profile_withdraw_pass: 'Withdrawal Password',
  profile_bank_card: 'Bank Card',
  profile_avatar: 'Avatar',
  profile_privacy: 'Privacy Policy',

  // ====== Settings Page ======
  settings_title: 'Settings',
  settings_account_security: 'ACCOUNT SECURITY',
  settings_email: 'Email Address',
  settings_not_set: 'Not Set',
  settings_bind: 'BIND',
  settings_unbind: 'UNBIND',
  settings_social_binding: 'SOCIAL BINDING',
  settings_preferences: 'PREFERENCES',
  settings_language: 'Language',
  settings_push: 'Push Notifications',
  settings_sound: 'Sound Volume',
  settings_bind_phone: 'Bind Phone',
  settings_not_bound: 'Not Bound',

  // ====== Edit Profile Page ======
  editProfile_title: 'EDIT PROFILE',
  editProfile_save: 'SAVE',
  editProfile_user_id: 'User ID',
  editProfile_nickname: 'Nickname',
  editProfile_nickname_ph: 'Enter nickname',
  editProfile_birthday: 'Birthday',

  // ====== Password Success Page ======
  pwdSuccess_header: 'PASSWORD UPDATED',
  pwdSuccess_title: 'Successfully Updated!',
  pwdSuccess_desc: 'Your account password has been changed. Please use your new credentials for future logins.',
  pwdSuccess_done: 'DONE',
  pwdSuccess_footer: 'Secure Account Management',
  pwdConfirm_ph: 'Confirm new password',
  pwdConfirm_mismatch: 'Passwords do not match',

  // ====== Transaction Records Page ======
  txRecords_title: 'Transaction Records',

  // ====== Phone Unbound Page ======
  phoneUnbound_title: 'PHONE SECURITY',
  phoneUnbound_status: 'NO PHONE NUMBER LINKED',
  phoneUnbound_desc: 'Link your phone number to enhance account security, enable SMS alerts, and recover your account easily.',
  phoneUnbound_bind: 'BIND PHONE',
  phoneUnbound_level: 'Security Level:',

  // ====== Mine Page ======
  mine_main: 'Main',
  mine_bonus: 'Bonus',
  mine_cashback: 'Cashback',
  mine_community: 'Community',

  // ====== Google Login ======
  google_login: 'Sign in with Google',
  google_register_title: 'Complete Registration',
  google_register_phone: 'Enter phone number',
  google_login_url_failed: 'Failed to get Google login URL',
  google_login_failed: 'Google login failed',
  google_register_failed: 'Registration failed',
  network_error: 'Network error',
  common_loading: 'Loading...',
  login_captcha_placeholder: 'Enter verification code',
  login_captcha_send: 'Send',
  // ====== Google Phone Binding ======
  gpb_title: 'Bind Phone',
  gpb_desc: 'Please bind your phone number to complete registration and secure your account',
  gpb_phone_placeholder: 'Enter phone number',
  gpb_confirm: 'Confirm Binding',
  gpb_confirm_title: 'Notice',
  gpb_confirm_msg: 'Not binding a phone number will log you out. Are you sure?',
  gpb_confirm_yes: 'Yes',
  gpb_confirm_no: 'No',
  // ====== VIP ======
  vip_title: 'VIP Levels',
  vip_level_progress: 'Level Progress',
  vip_tier_advancement: 'Tier Advancement',
  vip_xp_remaining: 'XP remaining to reach Level',
  vip_exclusive_privileges: 'Exclusive Privileges',
  vip_level_up_reward: 'Level Up Reward',
  vip_daily_reward: 'Daily Reward',
  vip_birthday_gift: 'Birthday Gift',
  vip_withdrawal_fee: 'Withdrawal fee waived',
  vip_daily_withdrawal: 'Daily Withdrawal',
  vip_withdrawal_limit: 'Withdrawal Limit',
  vip_loss_rebate: 'Loss Rebate',
  vip_locked: 'Locked',
  vip_my_gifts: 'My Gifts',
  vip_not_reached: 'Not Reached',
  vip_claimable: 'Claimable',
  vip_claimed: 'Claimed',
  rp_title: 'Red Packet Rain',
  rp_not_qualified: 'Complete a Deposit to Unlock',
  rp_not_open: 'Activity Not Yet Open',
  rp_not_open_desc: 'Please check back later',
  rp_not_qualified_desc: 'Make a deposit in the last 3 days to participate in Red Packet Rain',
  rp_countdown: 'Next Round In',
  rp_round_active: 'Tap to Grab!',
  rp_claimed: 'Claimed This Round',
  rp_round_ended: 'Round Ended',
  rp_next_round: 'Next Round',
  rp_remaining: 'Remaining',
  rp_clicks: 'Clicks',
  rp_total_award: 'Total Award',
  rp_your_reward: 'Your Reward',
  rp_go_deposit: 'Go Deposit',
  rp_history: 'History',
  rp_rules_title: 'How to Play',
  rp_rule_1: 'Deposit within the last 3 days to qualify',
  rp_rule_2: 'Tap falling red packets to grab rewards',
  rp_rule_3: 'Each round has limited clicks',
  rp_no_history: 'No records yet',
  rp_packets_left: 'Packets Left',
  rp_round_time: 'Round Time',
  rp_grab_success: 'Congratulations!',
  // ====== Additional i18n Keys ======
  checkin_premium_desc: 'Premium rewards are unlocked after daily payment. Accumulate 10 deposits for a Mega Spin!',
  checkin_coins: 'Coins',
  checkin_deposit_for: 'DEPOSIT FOR',
  checkin_missed: 'MISSED',
  lr_title: 'LUCKY REFERRAL',
  lr_spin_x: 'SPIN',
  lr_live_feed: 'Live Feed',
  ng_best_value: 'BEST VALUE',
  ng_active: 'Active',
  ng_total_value: 'TOTAL VALUE',
  menu_region: 'Region',
  reward_no_data: 'No rewards found',
  rp_hour: 'H',
  rp_min: 'M',
  rp_sec: 'S',
  rc_first_deposit_bonus: 'First Deposit Bonus',
  vip_level_text: 'Level',
  vip_recharge_progress: 'RECHARGE PROGRESS',
  vip_bet_progress: 'BET PROGRESS',
  vip_next_level: 'NEXT LEVEL',
  /* === VUKAVI i18n 补全 2026-06-10 续(fr/pt 本地化) === */
  notice_title: 'Notice'
}
